import React, { FC, ReactNode } from 'react'

interface SectionCardProps {
  title?: ReactNode
  children: ReactNode
  style?: React.CSSProperties
}

const TITLE_STYLE: React.CSSProperties = {
  fontFamily: 'Roboto',
  fontWeight: 400,
  fontSize: 16,
  lineHeight: '24px',
  color: '#5F5F5F',
  marginBottom: 8,
}

const BASE_STYLE: React.CSSProperties = {
  background: '#fff',
  borderRadius: 8,
  padding: '20px 24px',
  marginBottom: 16,
  border: '1px solid #f0f0f0',
}

const SectionCard: FC<SectionCardProps> = ({ title, children, style }) => (
  <div style={{ marginBottom: 16 }}>
    {title && <div style={TITLE_STYLE}>{title}</div>}
    <div style={{ ...BASE_STYLE, marginBottom: 0, ...style }}>{children}</div>
  </div>
)

export default SectionCard
